import { deprecated } from "typesafe-actions";

import type { ISessionData } from "@/shop/types/session";

import { SessionActionType } from "./constants";

const { createStandardAction } = deprecated;

export const fetchSession = createStandardAction(SessionActionType.FETCH_SESSION)();

export const updateDebitor = createStandardAction(SessionActionType.UPDATE_DEBITOR).map(
  (payload: { debitorNumber: string; preservePunchoutSession?: true }) => ({
    payload
  })
);

export const updateLanguage = createStandardAction(SessionActionType.UPDATE_LANGUAGE).map((languageCode: string) => ({
  payload: languageCode
}));

export const sessionSyncSuccess = createStandardAction(SessionActionType.SET_SESSION_DATA).map((data: ISessionData) => ({
  payload: data
}));

export const sessionSyncFail = createStandardAction(SessionActionType.SESSION_SYNC_FAIL).map((err: Error) => ({
  payload: err,
  error: true
}));

export const logoutSession = createStandardAction(SessionActionType.LOGOUT_SESSION)();
